/**
 * Возвращает публичное имя пользователя.
 * Если задан displayName — использует его, иначе firstName + lastName.
 */
export function getDisplayName(user: {
  displayName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
} | null | undefined): string {
  if (!user) return 'Пользователь';
  if (user.displayName?.trim()) return user.displayName.trim();
  return [user.firstName, user.lastName].filter(Boolean).join(' ') || 'Пользователь';
}
